import { styled } from "@mui/material";
import { useMessageBoxContext } from "@src/MessageBoxView/context/MessageBoxContext";

import { MessageBox } from "../components/MessageBox";

export const MessageBoxSlideOutWidget1 = styled(MessageBox)(() => {
  const { widget } = useMessageBoxContext();
  const isTopLeft = widget.styles.placement === "top-left";
  return {
    borderRadius: `${isTopLeft ? "0px" : widget.styles.container.cornerRadius} ${isTopLeft ? widget.styles.container.cornerRadius : "0px"} ${isTopLeft ? widget.styles.container.cornerRadius : 0} ${isTopLeft ? "0px" : widget.styles.container.cornerRadius}`,
  };
});
